var exports = {
  "Tc": "ChannelUserTag.module__tag___bW44aF",
  "Dm": "ChannelUserTag.module__tagSm___bW44aF",
  "ST": "ChannelUserTag.module__tagLg___bW44aF",
  "Qq": "ChannelUserTag.module__text___bW44aF",
  "WV": "ChannelUserTag.module__textSm___bW44aF",
  "j": "ChannelUserTag.module__textLg___bW44aF",
};

module.exports = exports;
